/*@flow*/
import getCompanyId from 'lib/getCompanyId';
import type {
  FiltersInput,
  FilterByInput,
  StreetscapeAssets,
} from 'comps/ProjectPopup/queries/__generated__/getPopupProjects';
import apolloClient from 'store/apollo';
import {
  // Statuses
  GetStreetscapeAssetStatuses,
  GetStreetscapeIssueStatuses,
  GetListingStatuses,
  GetTenantStatuses,
  GetUnitStatuses,
  GetAttractionStatuses,
  GetEventStatuses,
  GetContactStatuses,
  GetBuildingStatuses,
  GetPropertyStatuses,
  GetDevelopmentStatuses,
  // Categories
  GetAssetType,
  GetAssetSubtype,
  GetBuildingCategories,
  GetBuildingSubcategories,
  GetPropertyCategories,
  GetTenantCategories,
  GetUnitCategories,
  GetUnitTags,
  GetTenantSubcategories,
  GetUnitSubcategories,
  GetAttractionCategories,
  GetAttractionSubcategories,
  GetEventCategories,
  GetIssueCategories,
  GetIssueSubcategories,
  GetIssueAssignableUsers,
  GetDataPanelTags,
  GetProjectTags,
  GetProjectStatuses,
  GetContactTypes,
  GetPropertyClasses,
  GetTaxClasses,
  GetDistrictClasses,
  GetMemberVenues,
  GetOrganizationStatuses,
  GetOrganizationCategories,
  GetOrganizationSubcategories,
} from '.';
import nested from 'lib/nested';
import type { DocumentNode } from 'graphql';

// TODO: improve the props type
const fetchData = function(q: DocumentNode, props: Object = {}): Promise<*> {
  const { client, ...variables } = props;
  const addDefaultVariables = (np) => {
    return { companyId: getCompanyId() || window.companyId, ...np };
  };
  const dataClient = client || apolloClient;
  return dataClient.query({
    variables: addDefaultVariables(variables),
    query: q,
  });
};

const drill = (path) => (o: Object) => nested(o, path);

type PropsT = { companyId?: ID, filters?: FiltersInput | FilterByInput };

export const assetTypeLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.streetscapeAssetTypes');
  return fetchData(GetAssetType, props).then(getValue);
};

export const streetscapeAssetStatusesLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.streetscapeAssetStatuses');
  return fetchData(GetStreetscapeAssetStatuses, props).then(getValue);
};

export const streetscapeIssueStatusesLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.streetscapeIssueStatuses');
  return fetchData(GetStreetscapeIssueStatuses, props).then(getValue);
};

export const assetSubtypeLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.streetscapeAssetSubtypes');
  return fetchData(GetAssetSubtype, props).then(getValue);
};

export const listingStatusesLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.listingStatuses');
  return fetchData(GetListingStatuses, props).then(getValue);
};

export const developmentStatusesLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.developmentStatuses');
  return fetchData(GetDevelopmentStatuses, props).then(getValue);
};

export const tenantStatusesLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.tenantStatuses');
  return fetchData(GetTenantStatuses, props).then(getValue);
};

export const unitStatusesLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.unitStatuses');
  return fetchData(GetUnitStatuses, props).then(getValue);
};

export const tenantCategoryLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.tenantCategories');
  return fetchData(GetTenantCategories, props).then(getValue);
};

export const tenantSubcategoryLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.tenantSubcategories');
  return fetchData(GetTenantSubcategories, props).then(getValue);
};

export const unitSubcategoryLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.unitSubcategories');
  return fetchData(GetUnitSubcategories, props).then(getValue);
};

export const organizationStatusesLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.organizationStatuses');
  return fetchData(GetOrganizationStatuses, props).then(getValue);
};

export const organizationCategoryLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.organizationCategories');
  return fetchData(GetOrganizationCategories, props).then(getValue);
};

export const organizationSubcategoryLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.organizationSubcategories');
  return fetchData(GetOrganizationSubcategories, props).then(getValue);
};

export const unitCategoryLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.unitCategories');
  return fetchData(GetUnitCategories, props).then(getValue);
};

export const unitTagsLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.unitTags');
  return fetchData(GetUnitTags, props).then(getValue);
};

export const attractionStatusesLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.attractionStatuses');
  return fetchData(GetAttractionStatuses, props).then(getValue);
};

export const attractionCategoryLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.attractionCategories');
  return fetchData(GetAttractionCategories, props).then(getValue);
};

export const attractionSubcategoryLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.attractionSubcategories');
  return fetchData(GetAttractionSubcategories, props).then(getValue);
};

export const eventStatusesLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.eventStatuses');
  return fetchData(GetEventStatuses, props).then(getValue);
};

export const eventCategoryLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.eventCategories');
  return fetchData(GetEventCategories, props).then(getValue);
};

export const contactStatusesLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.contactStatuses');
  return fetchData(GetContactStatuses, props).then(getValue);
};

export const contactTypeLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.contactTypes');
  return fetchData(GetContactTypes, props).then(getValue);
};

export const issueCategoryLoader = (
  props: {
    companyId?: ID,
    streetscapeAssetFilters?: StreetscapeAssets,
    client?: Object,
  } = {}
): Promise<any[]> => {
  const getValue = drill('data.company.streetscapeIssueCategories');
  return fetchData(GetIssueCategories, props).then(getValue);
};

export const issueSubcategoryLoader = (
  props: {
    companyId?: ID,
    streetscapeAssetFilters?: StreetscapeAssets,
    client?: Object,
  } = {}
): Promise<any[]> => {
  const getValue = drill('data.company.streetscapeIssueSubcategories');
  return fetchData(GetIssueSubcategories, props).then(getValue);
};

export const issueAssignableUsersLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.streetscapeIssueAssignableUsers');
  return fetchData(GetIssueAssignableUsers, props).then(getValue);
};

export const dataPanelTagLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.dataPanelTags');
  return fetchData(GetDataPanelTags, props).then(getValue);
};

type TagPropsT = PropsT & { filterName: string };

export const projectTagLoader = (props: TagPropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.projectTags');
  return fetchData(GetProjectTags, props).then(getValue);
};

export const projectStatusesLoader = (
  props: TagPropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.projectStatuses');
  return fetchData(GetProjectStatuses, props).then(getValue);
};

export const propertyClassLoader = (props: any = {}): Promise<any[]> => {
  const getValue = drill('data.company.propertyClasses');
  return fetchData(GetPropertyClasses, props).then(getValue);
};

export const taxClassLoader = (props: any = {}): Promise<any[]> => {
  const getValue = drill('data.me.company.taxClasses');
  return fetchData(GetTaxClasses, props).then(getValue);
};

export const districtClassLoader = (props: any = {}): Promise<any[]> => {
  const getValue = drill('data.me.company.districtClasses');
  return fetchData(GetDistrictClasses, props).then(getValue);
};

export const buildingStatusesLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.buildingStatuses');
  return fetchData(GetBuildingStatuses, props).then(getValue);
};

export const buildingCategoryLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.buildingCategories');
  return fetchData(GetBuildingCategories, props).then(getValue);
};

export const buildingSubcategoryLoader = (
  props: PropsT = {}
): Promise<any[]> => {
  const getValue = drill('data.company.buildingSubcategories');
  return fetchData(GetBuildingSubcategories, props).then(getValue);
};

export const propertyStatusesLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.propertyStatuses');
  return fetchData(GetPropertyStatuses, props).then(getValue);
};

export const propertyCategoryLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.propertyCategories');
  return fetchData(GetPropertyCategories, props).then(getValue);
};

export const memberVenuesLoader = (props: PropsT = {}): Promise<any[]> => {
  const getValue = drill('data.company.resources');
  return fetchData(GetMemberVenues, props).then(getValue);
};
